// Replicate the exact working document library metadata utilities

const tryParseJson = (value) => {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};

const unwrapMetaValue = (value) => {
  if (value && typeof value === 'object' && value.value !== undefined) {
    return value.value;
  }
  return value;
};

export const getDocMetadata = (doc) => {
  if (!doc) return {};

  const rawCandidate =
    doc.metadata ??
    doc.extracted_metadata ??
    doc.extractedMetadata ??
    doc.ai_metadata ??
    doc.aiMetadata ??
    doc.indexedFields ??
    doc.fields ??
    {};

  const rawParsed = tryParseJson(rawCandidate);

  if (!rawParsed || typeof rawParsed !== 'object') return {};

  const out = {};
  for (const [k, v] of Object.entries(rawParsed)) {
    out[k] = unwrapMetaValue(tryParseJson(v));
  }
  return out;
};

const toSnake = (s) => s.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);
const toCamel = (s) => s.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

const SYNONYMS = {
  vendorName: ['vendor', 'supplier', 'supplierName'],
  invoiceNumber: ['invoice_no', 'invoiceNum', 'invNumber'],
  poNumber: ['po', 'purchaseOrder', 'purchaseOrderNumber'],
  amount: ['total', 'totalAmount', 'invoiceTotal', 'grandTotal'],
};

export const getDocumentFieldValue = (doc, fieldKey) => {
  if (!doc || !fieldKey) return '';
  const meta = getDocMetadata(doc);

  if (meta[fieldKey]) return meta[fieldKey];

  const snake = toSnake(fieldKey);
  if (meta[snake]) return meta[snake];

  const camel = toCamel(fieldKey);
  if (meta[camel]) return meta[camel];

  const syns = SYNONYMS[fieldKey];
  if (syns) {
    for (const k of syns) {
      if (meta[k]) return meta[k];
    }
  }

  return '';
};
